import ValueX from '../types/ValueX';

export default class DueX extends ValueX {
    static __className = 'DueX';

    constructor(constructJson) {
        super(constructJson, 'due', 'DueX');
    }
}
